// Plugin para cerrar si el foco se va fuera del reference o popper
const hideOnPopperBlur = {
    name: 'hideOnPopperBlur',
    defaultValue: true,
    fn(instance) {
      function handleFocusOut(event) {
        if (
          instance.props.hideOnPopperBlur &&
          event.relatedTarget &&
          !instance.popper.contains(event.relatedTarget) &&
          !instance.reference.contains(event.relatedTarget)
        ) {
          instance.hide();
        }
      }
  
      return {
        onCreate() {
          instance.popper.addEventListener('focusout', handleFocusOut);
          instance.reference.addEventListener('focusout', handleFocusOut);
        },
        onDestroy() {
          instance.popper.removeEventListener('focusout', handleFocusOut);
          instance.reference.removeEventListener('focusout', handleFocusOut);
        },
      };
    },
  };
  // Plugin para cerrar con tecla Escape
  const hideOnEsc = {
    name: 'hideOnEsc',
    defaultValue: true,
    fn({ hide }) {
      function onKeyDown(event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
          hide();
        }
      }
      return {
        onShow() {
          document.addEventListener('keydown', onKeyDown);
        },
        onHide() {
          document.removeEventListener('keydown', onKeyDown);
        },
      };
    },
  };
  
  // Inicialización de Tippy con ambos plugins
  tippy('.js-profile-tooltip', {
    content(reference) {
      const selector = reference.getAttribute('data-tooltip');
      const target = document.querySelector(selector);
      return target ? target.innerHTML : 'No content';
    },
    allowHTML: true,
    interactive: true,
    placement: 'bottom',
    role: 'dialog',
    trigger: 'mouseenter focus',
    plugins: [hideOnPopperBlur, hideOnEsc],
    hideOnPopperBlur: true,
    hideOnEsc: true,
  });
  